import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutUs.css';

const AboutUs = () => {
  const navigate = useNavigate();

  return (
    <div className="about-wrapper">
      <div className="about-header">
        <button className="about-back" onClick={() => navigate(-1)}>← Back</button>
      </div>

      <div className="about-hero">
        <img src="/logo.png" alt="Manthrakodi Matrimony" style={{ height: 120, marginBottom: 16 }} />
        <p className="about-tagline">Where traditions meet modern matchmaking</p>
      </div>

      <div className="about-content">
        <div className="about-section">
          <h2>About Us</h2>
          <p>
            Manthrakodi is a trusted matrimonial platform rooted in tradition and powered by technology.
            We help families and individuals find their perfect life partner with verified profiles,
            privacy-first approach, and a deep understanding of cultural values.
          </p>
          <p>
            Our mission is to make the journey of finding a life partner simple, safe, and meaningful.
            Whether you're looking for a match within your community or exploring beyond,
            Manthrakodi is here to guide you every step of the way.
          </p>
        </div>

        <div className="about-section">
          <h2>Why Manthrakodi?</h2>
          <div className="about-features">
            <div className="about-feature">
              <span className="about-feature-icon">✓</span>
              <div>
                <h3>Verified Profiles</h3>
                <p>Every profile goes through phone verification to ensure authenticity.</p>
              </div>
            </div>
            <div className="about-feature">
              <span className="about-feature-icon">🔒</span>
              <div>
                <h3>Privacy Protected</h3>
                <p>Your contact details are hidden until you choose to share them.</p>
              </div>
            </div>
            <div className="about-feature">
              <span className="about-feature-icon">👨‍👩‍👧‍👦</span>
              <div>
                <h3>Trusted by Families</h3>
                <p>Built with family values at the core, trusted by thousands of families.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="about-section about-contact">
          <h2>Contact Us</h2>
          <div className="about-contact-grid">
            <div className="about-contact-card">
              <span className="about-contact-icon">📍</span>
              <h3>Address</h3>
              <p>Manthrakodi Matrimoni</p>
              <p>Kannadiparamba</p>
              <p>Kannur 670604, Kerala</p>
            </div>
            <div className="about-contact-card">
              <span className="about-contact-icon">✉️</span>
              <h3>Support</h3>
              <p>
                <a href="mailto:support.manthrakodi@gmail.com">support.manthrakodi@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
